import { useEffect } from 'react';
import useIsMobile from './useIsMobile';

// The one primary action of a phone screen, pinned above the tab bar.
// On desktop it renders inline where it is placed. While mounted on a
// phone it pads the page bottom (body.has-sticky) so content can scroll
// clear of it.
export default function StickyAction({ children }) {
  const isMobile = useIsMobile();
  useEffect(() => {
    if (!isMobile) return undefined;
    document.body.classList.add('has-sticky');
    return () => document.body.classList.remove('has-sticky');
  }, [isMobile]);
  return <div className={isMobile ? 'm-sticky' : 'm-sticky-inline'}>{children}</div>;
}
